import logo from "../../assets/images/logo.png"

export default function Logo () {
  return (
    <div className="size-16 bg-contain bg-no-repeat cursor-pointer bg-center" style={{backgroundImage: `url("${logo}")`}}>

    </div>
  )
}
